import BaseMoney from 'presentation/components/BaseMoney/BaseMoney.vue';
import BaseDate from 'presentation/components/BaseDate/BaseDate.vue';
import Spinner from 'presentation/components/Spinner/Spinner.vue';
import Pagination from 'presentation/components/Pagination/Pagination.vue';
import BaseForm from 'presentation/components/BaseForm/BaseForm.vue';
import BaseInput from 'presentation/components/BaseInput/BaseInput.vue';
import BaseSelector from 'presentation/components/BaseSelector/BaseSelector.vue';
import ServerError from 'presentation/components/ServerError/ServerError.vue';
import useCustomerTools from 'hooks/useCustomerTools';

import {useI18n} from 'vue-i18n';
import {ref} from "vue";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";

function Rules() {
  this.Pet_age = {required};
  this.Pet_Size = {required};
  this.Pet_name = {required};
  this.Pet_breed = {required};
  this.Allergies__diseases = {required};
  this.Vaccinations = {required};
  // this.short_description = {required};
  // this.Extra_information = {required};
  // this.image = {};
}

export default {
  components: {
    BaseMoney,
    BaseDate,
    Spinner,
    Pagination,
    BaseForm,
    BaseInput,
    BaseSelector,
    ServerError,
  },
  setup() {
    const form = ref({
      Pet_age: '',
      Pet_Size: '',
      Pet_name: '',
      Pet_breed: '',
      Allergies__diseases: '',
      Vaccinations: '',
      description: '',
      // short_description: '',
      // Extra_information: '',
      // image: ''
    });
    const rules = new Rules(form);
    const v = useVuelidate(rules, form);
    const {t} = useI18n();

    const tools = useCustomerTools();
    const customerCreatePet = () =>
      tools.customerCreatePet(form.value);

    return {
      t,
      v,
      customerCreatePet,
    };
  },
};
